import { ChangeEvent, FC, useCallback } from 'react';

import {
  ProgressButton,
  TextArea,
} from '@beeline/design-system-react/extracted-styles';

import { FeedbackTypeSelect } from '../FeedbackTypeSelect/FeedbackTypeSelect';
import { FullscreenDialog } from '../FullscreenDialog/FullscreenDialog';

import { useFeedbackDialog } from './FeedbackDialogProvider';

const maxMessageLength = 500;

export interface FeedbackDialogProps {
  rootId: string;
}

export const FeedbackDialog: FC = () => {
  const {
    isOpen,
    close,
    feedbackType,
    setFeedbackType,
    message,
    setMessage,
    submit,
  } = useFeedbackDialog();

  const changeMessage = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      setMessage(e.target.value);
    },
    [setMessage],
  );

  return (
    <FullscreenDialog
      isOpen={isOpen}
      close={close}
      contentWidth='506px'
      title='Обратная связь'
      dialogTestId='feedbackDialog'
      titleTestId='feedbackDialogTitle'
      closeTestId='closeFeedbackDialog'
      actions={
        <ProgressButton
          variant='contained'
          onClick={submit}
          data-testid='sendFeedback'
          statusDelayTime={0}
        >
          Отправить
        </ProgressButton>
      }
    >
      <FeedbackTypeSelect
        value={feedbackType}
        onChange={setFeedbackType}
        testId='feedbackDialogType'
      />
      <TextArea
        value={message}
        onChange={changeMessage}
        placeholder='Опишите проблему'
        fullWidth
        maxLength={maxMessageLength}
        dataTestId='feedbackDialogMessage'
      />
    </FullscreenDialog>
  );
};
